import DeleteSharpIcon from '@mui/icons-material/DeleteSharp';
import SearchIcon from '@mui/icons-material/Search';
import SyncIcon from '@mui/icons-material/Sync'; // add to mui imports at top
import { IconButton, InputAdornment, OutlinedInput, Toolbar, Tooltip, Typography } from '@mui/material';
import { alpha, styled, useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const SearchDesk = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    // boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

const SearchMobile = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  // fontSize: theme.typography.p.fontSize,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
}));

export default function UserListToolbar({ numSelected, filterName, onFilterName, handleDelete, handleReAuthAll, reAuth = false }) {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const StyledSearch = isMobile ? SearchMobile : SearchDesk;

  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} {translate('common.selected')}
        </Typography>
      ) : (
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder="Search user..."
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton onClick={handleDelete}>
            <DeleteSharpIcon />
          </IconButton>
        </Tooltip>
      ) : (
        // ── Only renders when reAuth=true (IntegratdAccounts + isOrgAdmin) ──
        reAuth && handleReAuthAll ? (
          <Tooltip title={translate('integration.reauth_all_fb_instagram')}>
            <IconButton
              size="small"
              onClick={handleReAuthAll}
              sx={{
                bgcolor: 'error.lighter',
                color: 'error.main',
                borderRadius: 1,
                px: 1.5,
                py: 0.5,
                gap: 0.5,
                '&:hover': { bgcolor: 'error.light' },
              }}
            >
              <SyncIcon fontSize="small" />
              <Typography variant="caption" fontWeight={600}>
                {translate('integration.reauth_all')}
              </Typography>
            </IconButton>
          </Tooltip>
        ) : (
          <></>
        )
      )}
    </StyledRoot>
  );
}